import { Component, inject } from '@angular/core';
import { ActivityGroupService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ActivityGroupCreateDto,
  ActivityGroupDto,
  ActivityGroupExcelDownloadDto,
  ActivityGroupUpdateDto,
} from '../proxy/controlling/dtos/activity-group';
import { ACTIVITYGROUP_CONFIG, ACTIVITYGROUP_FIELDS } from './activity-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-activity-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ActivityGroupService, ConfirmationService],
  templateUrl: './activity-group.html',
  styleUrl: './activity-group.scss',
})
export class ActivityGroup extends BaseCrudComponent<
  ActivityGroupDto,
  ActivityGroupCreateDto,
  ActivityGroupUpdateDto,
  ActivityGroupExcelDownloadDto
> {
  service = inject(ActivityGroupService);
  config = ACTIVITYGROUP_CONFIG;
  fields = ACTIVITYGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: ActivityGroupDto): ActivityGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ActivityGroup';
  }
}
